// Module
var code = "<div class=map></div>";
// Exports
module.exports = code;